<template>
  <v-dialog
    :value="selectedOrderNumber"
    @input="clearOrderId"
    max-width="500"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    content-class="elevation-0"
  >
    <v-card>
      <confirmed-payment-view
        v-if="selectedOrderNumber"
        :key="selectedOrderNumber"
        :from-bringg-order="true"
        :is-tracking-popup="true"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import ConfirmedPaymentView from "@/views/Payment/Confirmed.vue";
import { mapState } from "vuex";

export default {
  name: "TrackingPopup",
  components: { ConfirmedPaymentView },
  computed: {
    ...mapState({
      selectedOrderNumber: (state) => state.orderStatus.selectedOrderNumber
    })
  },
  methods: {
    async clearOrderId() {
      this.orderId = 0;
      await this.$store.dispatch("orderStatus/updateCurrentOrderNumber", 0);
    }
  }
};
</script>
